
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import { State, Getter, Action } from "vuex-class";
import {
  getAreaDepartmentByLastCode,
  deepClone,
  setStorage,
  getStorage,
  clearStorage,
  getParentArea,
} from "@/common/utils";
import { getAddressItem, getDept } from "@/api/common";
@Component({
  name: "Marquee",
  components: {},
})
export default class Marquee extends Vue {
  @Action("getNature") private getNature: any;
  @Getter("city") private city: any;
  @Getter("cityId") private cityId: any;
  @Getter("provinceId") private provinceId: any;
  @Getter("cityName") private cityName: any;
  @State("centerData") private centerData: any;
  @State("directCityList") private directCityList: any;
  areaOption = this.$root.$data.areaOption;
  addRouteList: string[] = [
    // "/pcm/apply",
    "/person/apply",
    "/unit/apply",
    "/declare/apply",
    "/person/noApply",
    "/unit/noApply",
    "/declare/noApply",
  ];
  is_open = false;
  menu: any = [];
  async_menu: any = [
    {
      property: "state",
      title: "申报状态",
      btns: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "申报中",
          label: "兑现中",
        },
        {
          value: "已截止",
          label: "已截止",
        },
        {
          value: "未开始",
          label: "未开始",
        },
      ],
      route: [
        // "/pcm/apply",
        "/person/apply",
        "/unit/apply",
        "/declare/apply",
        "/person/noApply",
        "/unit/noApply",
        "/declare/noApply",
        "/kunming/apply",
      ],
      index: 0,
    },
    {
      property: "addressCode",
      title: "选择区划",
      btns: [],
      route: [
        "/pcm/apply",
        "/pcm/noApply",
        "/person/apply",
        "/pcm/inform",
        "/pcm/publicy",
        "/pcm/policy",
        "/unit/apply",
        "/declare/apply",
        "/kunming/policy",
        "/kunming/apply",
        "/person/noApply",
        "/unit/noApply",
        "/declare/noApply",
        "/pcm/media",
      ],
      index: 0,
    },
    {
      property: "nature",
      title: "政策类别",
      btns: [],
      route: [
        // "/pcm/noApply",
        // "/pcm/apply",
        // "/person/apply",
        // "/pcm/policy",
        // "/unit/apply",
        // "/declare/apply",
        // "/person/noApply",
        // "/unit/noApply",
        // "/declare/noApply",
        // "/pcm/publicy",
        // "/pcm/media",
      ],
      index: 0,
    },
    {
      property: "departmentId",
      title: "主管部门",
      btns: [],
      route: [
        // "/pcm/apply",
        // "/person/apply",
        // "/pcm/inform",
        // "/pcm/publicy",
        // "/pcm/noApply",
        // "/pcm/policy",
        // "/unit/apply",
        // "/declare/apply",
        // "/person/noApply",
        // "/unit/noApply",
        // "/declare/noApply",
        // "/kunming/policy",
        // "/kunming/apply",
        // "/pcm/media",
      ],
      index: 0,
    },
    {
      property: "indicators",
      title: "营商指标",
      btns: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "开办企业",
          label: "开办企业",
        },
        {
          value: "办理建筑许可",
          label: "办理建筑许可",
        },
        {
          value: "获得电力",
          label: "获得电力",
        },
        {
          value: "获得用水",
          label: "获得用水",
        },
        {
          value: "获得用气",
          label: "获得用气",
        },
        {
          value: "登记财产",
          label: "登记财产",
        },
        {
          value: "缴纳税费",
          label: "缴纳税费",
        },
        {
          value: "跨境贸易",
          label: "跨境贸易",
        },
        {
          value: "劳动力市场监管",
          label: "劳动力市场监管",
        },
        {
          value: "政府采购",
          label: "政府采购",
        },
        {
          value: "信用建设",
          label: "信用建设",
        },
        {
          value: "创新创业活跃度",
          label: "创新创业活跃度",
        },
        {
          value: "基本公共服务满意度",
          label: "基本公共服务满意度",
        },
        {
          value: "蓝天碧水净土森林覆盖",
          label: "蓝天碧水净土森林覆盖",
        },
        {
          value: "综合",
          label: "综合",
        },
      ],
      route: ["/kunming/policy"],
      index: 0,
    },
  ];
  add_menu: any = [
    {
      property: "money",
      title: "资金范围",
      route: [
        // "/pcm/apply",
        "/person/apply",
        "/unit/apply",
        "/declare/apply",
        "/person/noApply",
        "/unit/noApply",
        "/declare/noApply",
      ],
      btns: [
        {
          value: [null, null],
          label: "全部",
        },
        {
          value: [0, 100000],
          label: "0-10万",
        },
        {
          value: [100000, 500000],
          label: "10-50万",
        },
        {
          value: [500000, 1000000],
          label: "50-100万元",
        },
        {
          value: [1000000, null],
          label: "100万元以上",
        },
      ],
      index: 0,
    },
    {
      property: "year",
      title: "项目年度",
      route: [
        // "/pcm/apply",
        "/person/apply",
        "/pcm/inform",
        "/pcm/policy",
        "/unit/apply",
        "/declare/apply",
        "/person/noApply",
        "/unit/noApply",
        "/declare/noApply",
      ],
      btns: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "2019",
          label: "2019年",
        },
        {
          value: "2020",
          label: "2020年",
        },
        {
          value: "2021",
          label: "2021年",
        },
      ],
      index: 0,
    },
  ];
  natureOption: any = [];
  currentChildArr: any = [];
  currentDept: any = [];
  // according route list change menu
  async created() {
    await this.getData();
    await this.setMenu();
  }
  async getData() {
    if (getStorage("is_open")) {
      this.is_open = true;
    }
    clearStorage("is_open");
    this.natureOption = await this.getNature();
    let childArr = await getAddressItem(this.city.id);
    this.currentChildArr = [];
    childArr.data.result.forEach((item: any) => {
      this.currentChildArr.push({
        value: item.id,
        label: item.name,
      });
    });
  }
  current_menu: any = [];
  async setMenu() {
    try {
      // get current routeadd_menu
      const route_path = this.$route.path;
      // filter current route menu
      const current_menu = this.async_menu
        .filter((item: any) => {
          return item.route.includes(route_path);
        })
        .map((item: any) => {
          const defaultBtn = [{ value: null, label: "全部" }];
          let areaCode = "";
          if (item.property === "departmentId") {
            // 设置搜索部门的类型(0-搜索单个,1-搜索数组)
            if (this.menu.length === 0) {
              item.btns = defaultBtn;
            }
          } else if (item.property === "addressCode") {
            // 区划
            let currentProvince = this.areaOption.filter(
              (item: any) => item.id == this.city.provinceId
            );
            const cityId = this.cityId.toString();
            const dataForAllArea = getAreaDepartmentByLastCode(
              this.areaOption,
              cityId
            );

            const area = dataForAllArea ? dataForAllArea.children : [];
            const cityDepart = dataForAllArea ? dataForAllArea.depart : [];
            if (area) {
              const provinceItem: any = dataForAllArea?.parent;
              const provinceId = this.provinceId;
              const provinceName = provinceItem
                ? provinceItem.label
                : provinceItem;
              const provinceItemForDepart = getAreaDepartmentByLastCode(
                this.areaOption,
                provinceId
              );
              let proBtn: any = [
                {
                  value: provinceId,
                  label: provinceName,
                  depart: provinceItemForDepart?.depart || [],
                },
              ];
              let cityBtn: any = [
                {
                  value: cityId,
                  // label: this.cityName,
                  depart: cityDepart || [],
                  label: this.cityName,
                },
              ];
              const allArea = [];
              if (cityId === provinceId) {
                allArea.push(cityId);
              } else {
                allArea.push(cityId);
                allArea.push(provinceId);
              }
              if (this.directCityList.includes(cityId)) {
                cityBtn = [];
                proBtn[0].label = this.cityName;
                proBtn[0].value = this.cityId;
              }
              const centerBtn: Array<any> = this.centerData || [];
              allArea.push("100000");
              if (this.$route.path == "/pcm/publicy") {
                item.btns = [
                  {
                    value: allArea,
                    label: "全部",
                  },
                  {
                    value: currentProvince[0].id,
                    label: currentProvince[0].name,
                  },
                ]
                  .concat(centerBtn)
                  .concat(proBtn)
                  .concat(cityBtn)
                  .concat(area)
                  .concat(this.currentChildArr);
              } else {
                item.btns = [
                  {
                    value: allArea,
                    label: "全部",
                  },
                  {
                    value: "100000",
                    label: "国家",
                  },
                  {
                    value: currentProvince[0].id,
                    label: currentProvince[0].name,
                  },
                ]
                  .concat(centerBtn)
                  // .concat(proBtn)
                  .concat(cityBtn)
                  .concat(area)
                  .concat(this.currentChildArr);
              }
            } else {
              item.btns = defaultBtn;
            }
          } else if (item.property === "nature") {
            item.btns = defaultBtn.concat(this.natureOption);
          }
          return item;
        });
      this.current_menu = current_menu;
      if (!this.is_open) {
        this.menu = current_menu;
      } else {
        this.menu = current_menu.concat(this.add_menu);
      }
    } catch (err) {
      console.log(err);
    }
  }
  async setPartMenu(selectedItem: any, index: any) {
    if (selectedItem.property == "addressCode") {
      let deptArr = await getDept(selectedItem.btns[index].value);

      this.currentDept = [
        {
          value: null,
          label: "全部",
        },
      ];
      if (deptArr.data.result.length > 0) {
        deptArr.data.result.forEach((item: any) => {
          this.currentDept.push({
            value: item.id,
            label: item.departmentName,
          });
        });
      }
      this.menu[2].btns = this.currentDept;
    }

    // get current route
    // filter current route menu
    // const addressConectPropertyList = ["departmentId", "addressCode"];
    // // const natureConectPropertyList = ["nature", ""];
    // const defaultBtn = [{ value: null, label: "全部" }];
    // this.menu
    //   .filter((item: any) => {
    //     return item.property === "departmentId";
    //   })
    //   .map((item: any) => {
    //     const currentAddressCode = this.menu.find(
    //       ({ property }: any) => property === "addressCode"
    //     );
    //     const currentAddress =
    //       currentAddressCode.btns[currentAddressCode.index];
    //     item.btns = defaultBtn.concat(currentAddress.depart || []);
    //     return item;
    //   });
  }
  click(item: any, index: any) {
    if (item) {
      item.index = index;
    }
    // 如果选择区划,默认性质和主管部门设置为全部
    if (item.property === "addressCode") {
      this.async_menu.map((item: any) => {
        const resetList = ["departmentId", "nature"];
        if (resetList.includes(item.property)) {
          item.index = 0;
        }
        return item;
      });
    }

    this.setPartMenu(item, index);
    const options: any = {};
    for (const i of this.menu) {
      const single = i as any;
      if (single.property !== "money") {
        if (single.property == "addressCode") {
          if (single.index === 0) {
            options.addressCode = null;
            options.addressCodeList = null;
          } else {
            options[`${single.property}`] = single.btns[single.index].value
              ? single.btns[single.index].value.toString()
              : null;
          }
        } else if (single.property != "addressCode") {
          // options.addressCodeList = null;
          options[`${single.property}`] = single.btns[single.index].value
            ? single.btns[single.index].value.toString()
            : null;
        }
      } else {
        options.minMoney = single.btns[single.index].value[0];
        options.maxMoney = single.btns[single.index].value[1];
      }
    }
    if (this.is_open) {
      // 设置当前的展开状态缓存
      setStorage("is_open", "1");
    }
    this.$emit("search", options);
    // 设置点击状态的click
  }
  resetMenu() {
    this.async_menu = this.async_menu.map((item: any) => {
      item.index = 0;
      return item;
    });
    this.add_menu = this.add_menu.map((item: any) => {
      item.index = 0;
      return item;
    });
    this.menu = this.menu.map((item: any) => {
      item.index = 0;
      if (item.property == "departmentId") {
        item.btns = [{ value: null, label: "全部" }];
      }
      console.log(item, 87879);
      return item;
    });
  }
  @Watch("cityId")
  async handleCityChange() {
    await this.getData();
    await this.resetMenu();
    await this.setMenu();
    await this.$emit("default");
  }
}
